import { NavigateFunction } from "react-router";
import { STATUS } from "@/common/api/config";
import {
  CommonResponse,
  HandleErrorProps,
  ResponseData,
  ResponseError,
} from "@/common/api/types";
import { clearStorage } from "@/common/browserStorage/utils";

export const handleErrorMessage = ({
  setErrorMessage,
  response,
  error,
}: HandleErrorProps): void => {
  if (response && !response.success && response.message) {
    setErrorMessage(response.message);
    return;
  }
  if (error instanceof Error) {
    const errorMessage = error?.message || "Unknown error";
    setErrorMessage(errorMessage);
    return;
  }
  if (typeof error === "string") {
    setErrorMessage(error);
    return;
  }
  if (error) {
    const errorMessage = JSON.stringify(error) || "Unknown error";
    setErrorMessage(errorMessage);
    return;
  }
  return;
};

export const catchError = (response: Response): void => {
  if (response.status === STATUS.UNAUTHORIZED) {
    window.location.replace("/auth");
  }
  if (!response.ok) {
    throw new Error("Что-то пошло не так");
  }
};

type CustomErrorHandler = ({
  token,
  isFetched,
  response,
  error,
  catchError,
  navigate,
}: {
  token: string | null;
  isFetched: boolean;
  response?: ResponseData;
  error: ResponseError;
  catchError: (response?: CommonResponse, error?: any) => void;
  navigate: NavigateFunction;
}) => void;

export const customErrorHandler: CustomErrorHandler = ({
  token,
  isFetched,
  response,
  error,
  catchError,
  navigate,
}) => {
  if (token && isFetched && !response) {
    setTimeout(() => {
      clearStorage();
      navigate("/auth");
    });
  }

  if ((response && !response?.success) || error) {
    setTimeout(() => catchError(response, error));
  }
};
